export * from './fieldList';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
var PREFIX_FOR_TEST_IDS = 'website-form';

/** test ids for form and sections inside it */
export var testIds = {
  WEBSITE_FORM: "".concat(PREFIX_FOR_TEST_IDS, "-test-id"),
  PUB_ONLINE_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-pub-online-sec-test-id")
};

/** pub online section name and title */
export var PUB_ONLINE_SECTION_NAME = 'pubonline';
export var PUB_ONLINE_SECTION_TITLE = 'Online publication info';

/** function options for contributor - webiste form */
export var WebsiteContributorFunctionOptions = [FunctionTypes.AUTHOR, FunctionTypes.EDITOR, FunctionTypes.TRANSLATOR];